// extracted by mini-css-extract-plugin
module.exports = {"container":"AtEventLpTitle_container__3jd_p","header":"AtEventLpTitle_header__2zgpM","smallHeader":"AtEventLpTitle_smallHeader__3y2C7"};